import {defineStore} from 'pinia';
import redirect_error_page from "@/util/redirect_error_page"
import { useVersionStore } from './version_store';
import apiRequest from '@/util/api-request';
import { AxiosRequestConfig } from 'axios';


export const useLearningStatusStore = defineStore('learningStatusStore', {
    // actions
    actions: {
        async fetchTotalSummary() {
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'get',
                    url: '/student/api/learning_status/total_summary',
                };
                const result = await apiRequest(config);
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.total_summary
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchCalendarRange() {
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'get',
                    url: '/student/api/learning_status/calendar_range',
                };
                const result = await apiRequest(config);
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.calendar_range
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchMonthlySummary(payload:{year: number, month: number}) {
            const versionStore = useVersionStore()
            try {
                const config: AxiosRequestConfig = {
                    method: 'post',
                    url: '/student/api/learning_status/monthly_summary',
                    data: payload,
                };
                const result = await apiRequest(config);
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.monthly_summary.calendar
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
    }
})